import * as React from 'react';

import {CheckboxButton} from 'shells/button/checkbox-button/checkbox-button';

type Props = {
    label: string;
    checked: boolean;
    onChange: () => void;
    noPadding?: boolean;
};

export function AllowBookingButton(props: Props) {
    return (
        <CheckboxButton
            label={props.label}
            checked={props.checked}
            onChange={props.onChange}
            noPadding={props.noPadding}
        />
    );
}
